import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  actionButton: {
    color: theme.palette.common.white,
  },
}));
